import { getConfig } from '../config';

export const getIconUrl = (url: string) => {
  const appConfig = getConfig();
  if (appConfig.cdnURL && url) {
    const currentUrl = url.indexOf('/') === 0 ? url : `/${url}`;
    return `${appConfig.cdnURL}/ingame-website${currentUrl}`;
  }
  return url;
};
